export const contactAndLegal = {
  verificationInfo: "Verification Info",
  contactEmail: "Contact Email",
  contactInfo: "Contact Info",
  // ===============================================================
};
